export default {
    ACTION_ERROR: 'ACTION_ERROR',
    DISMISS_ACTION_ERROR: 'DISMISS_ACTION_ERROR',
};
